module.exports = __webpack_public_path__ + "static/media/filerequestdark.9ed71763.svg";